module.exports = __webpack_public_path__ + "static/media/icon-supplies-toothbrush.c82ad768.svg";